// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrderSelection__wrapper___+0ebm","column":"OrderSelection__column___fGYai"};